import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";

import PermissionChecker from '../../components/permissions/PermissionChecker';
import {VIEWS_TITLES, API_PERMISSIONS} from '../../globals';
import currentUser from '../../store/currentUser';


const styles = theme => ({
  link: {
    textDecoration: 'none',
    color: theme.palette.text.primary,
    width: 0,
    '&[disabled]': {
      pointerEvents: 'none',
    },
  },
  icon: {
    justifyContent: 'center',
    opacity: 0.6,
    '.Mui-selected &': {
      opacity: 1,
    }
  },
  text: {
    fontSize: 12,
    '.Mui-selected &': {
      color: '#FFF',
      fontWeight: 800,
    },
  },
  selected: {},
});


@withStyles(styles)
@withRouter
class NavigationListItem extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
    exact: PropTypes.bool,
    icon: PropTypes.element,
    textLink: PropTypes.bool,
  };

  static defaultProps = {
    title: null,
    exact: false,
    textLink: false,
    icon: null,
  };

  get title() {
    const { title } = this.props;
    if (title === null) {
      return VIEWS_TITLES[this.paths[0]];
    }
    return title;
  }

  get isSelected() {
    const { exact, location } = this.props;
    const currentPath = location.pathname;
    return this.paths.some(
      path => exact ? currentPath === path : currentPath.startsWith(path)
    );
  }

  get paths() {
    const { path } = this.props;
    return Array.isArray(path) ? path : [path];
  }

  get to() {
    for (const path of this.paths) {
      if (!(path in API_PERMISSIONS) || currentUser.can(API_PERMISSIONS[path])) {
        return path;
      }
    }
    return this.paths[0];
  }

  get permission() {
    const permissions = (
      this.paths.filter(singlePath => singlePath in API_PERMISSIONS)
      .map(singlePath => API_PERMISSIONS[singlePath])
    );
    if (permissions.length === 0) {
      return true;
    }
    return permissions;
  }

  render() {
    const { children, classes } = this.props;
    return (
      <PermissionChecker permission={this.permission}>
        {
          hasPermission =>
            <Link to={this.to} className={classes.link} disabled={!hasPermission}>
              <ListItem
                button
                selected={this.isSelected}
                disableGutters
                disabled={!hasPermission}
              >
                <ListItemIcon className={classes.icon}>
                  {children}
                </ListItemIcon>
                <ListItemText disableTypography>
                  <Typography
                    variant="inherit"
                    className={classes.text}
                    noWrap
                  >
                    {this.title}
                  </Typography>
                </ListItemText>
              </ListItem>
            </Link>
        }
      </PermissionChecker>
    );
  }
}


export default NavigationListItem;
